

export enum HorizontalPosition {
    LEFT    = 'left',
    RIGHT   = 'right',
}
